import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaInput from './VaInput.vue'

export const VaInput = withConfigTransport(_VaInput)
